"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstateLedgerInputSchema = exports.LEDGER_KINDS = exports.EstateLeaseSchema = exports.EstateMasterLeaseAuditEventSchema = exports.EstateMasterLeaseVersionSchema = exports.EstateLeaseAuditEventSchema = exports.ESTATE_LEASE_AUDIT_TYPES = exports.EstateLeaseDocVersionSchema = exports.EstateLeaseAttestationSchema = exports.EstateLeaseDocumentStateSchema = exports.EstateLeaseReviewSectionSchema = exports.EstateLawReviewSchema = exports.EstateLawSuggestionSchema = exports.EstateLawSourceSchema = exports.EstateLeaseSignedOutsideSchema = exports.EstateLeaseActorSchema = exports.EstateLeaseInputSchema = exports.EstateLeaseExtrasSchema = exports.EstateLeaseSigningSchema = exports.EstateLeaseSigningSignerSchema = exports.ESTATE_LEASE_SIGNING_SIGNER_STATUSES = exports.ESTATE_LEASE_SIGNING_STATUSES = exports.ESTATE_LEASE_SIGNER_ROLES = exports.EstateLeaseGuarantorSchema = exports.EstateResidentSchema = exports.EstateResidentInputSchema = exports.EstateResidentScreeningSchema = exports.ESTATE_SCREENING_KINDS = exports.ESTATE_UNIT_SECTION_DEFAULTS = exports.EstateUnitSchema = exports.EstateUnitInputSchema = exports.EstateUnitNoticeSchema = exports.EstateUnitEquipmentSchema = exports.EstateUnitUtilitySchema = exports.EstateUnitStorageSchema = exports.ESTATE_EQUIPMENT_KINDS = exports.ESTATE_UNIT_UNAVAILABLE_REASONS = exports.ESTATE_UNIT_SECTIONS = exports.EstateListingSchema = exports.EstatePropertySchema = exports.EstatePropertyMasterLeaseStateSchema = exports.EstatePropertyInputSchema = exports.EstateRentEstimateSchema = exports.EstateAreaTrendPointSchema = exports.EstateLatestValuationSchema = exports.EstateValuationCompSchema = exports.EstateValuationPointSchema = exports.EstatePropertyFactsSchema = exports.EstatePropertySubtypeSchema = exports.ESTATE_PROPERTY_SUBTYPES = void 0;
exports.EstateSettingsSchema = exports.EstateApplicationSchema = exports.EstateApplicationInputSchema = exports.EstateVendorSchema = exports.EstateVendorInputSchema = exports.EstateWorkOrderSchema = exports.EstateWorkOrderInputSchema = exports.EstateResidentWorkOrderInputSchema = exports.EstateObligationSchema = exports.EstateObligationInputSchema = exports.EstateLedgerEntrySchema = void 0;
exports.estateUnitSectionShared = estateUnitSectionShared;
exports.estateUnitCounted = estateUnitCounted;
exports.estateUnitBlockReason = estateUnitBlockReason;
const zod_1 = require("zod");
// Ruby Estate entities (spec 2026-10-08). Money = integer cents. Dates = YYYY-MM-DD.
const id = zod_1.z.string().min(1).max(80);
const cents = zod_1.z.number().int().min(0).max(100000000);
const positiveCents = zod_1.z.number().int().min(1).max(100000000);
const isoDate = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'date must be YYYY-MM-DD');
const bps = zod_1.z.number().int().min(0).max(10000);
const text = (max) => zod_1.z.string().trim().max(max);
const keys = zod_1.z.array(zod_1.z.string().max(512)).max(30).default([]);
const Address = zod_1.z.object({
    line1: text(200).default(''), line2: text(200).default(''),
    city: text(100).default(''), state: text(50).default(''), zip: text(20).default(''),
}).default({});
const meta = { tenantId: id, createdAt: zod_1.z.string(), updatedAt: zod_1.z.string() };
// ── Property hub (spec 2026-10-11 §9 + §14) ──
exports.ESTATE_PROPERTY_SUBTYPES = [
    'single_family', 'multi_2_4', 'apartment', 'condo_townhome', 'adu',
    'retail', 'office', 'industrial', 'mixed_use', 'self_storage', 'other',
];
exports.EstatePropertySubtypeSchema = zod_1.z.enum(exports.ESTATE_PROPERTY_SUBTYPES);
const Geo = zod_1.z.object({ lat: zod_1.z.number().min(-90).max(90), lng: zod_1.z.number().min(-180).max(180) });
exports.EstatePropertyFactsSchema = zod_1.z.object({
    yearBuilt: zod_1.z.number().int().min(1600).max(2100).optional(),
    buildingSqft: zod_1.z.number().int().min(0).max(10000000).optional(),
    lotSqft: zod_1.z.number().int().min(0).max(1000000000).optional(),
    zoning: text(40).optional(),
    parcelNumber: text(60).optional(),
    floodZone: text(20).optional(),
    lastSale: zod_1.z.object({ date: isoDate, priceCents: cents }).optional(),
    taxAnnualCents: cents.optional(),
    source: zod_1.z.enum(['manual', 'rentcast']).default('manual'),
    fetchedAt: zod_1.z.string().max(40).optional(),
}).default({});
exports.EstateValuationPointSchema = zod_1.z.object({
    date: isoDate, valueCents: cents, lowCents: cents, highCents: cents,
    source: zod_1.z.enum(['rentcast', 'own']),
});
exports.EstateValuationCompSchema = zod_1.z.object({
    address: text(200), priceCents: cents,
    sqft: zod_1.z.number().int().min(0).max(10000000).optional(),
    beds: zod_1.z.number().min(0).max(50).optional(),
    baths: zod_1.z.number().min(0).max(50).optional(),
    distanceMi: zod_1.z.number().min(0).max(100).optional(),
    date: isoDate.optional(),
});
exports.EstateLatestValuationSchema = zod_1.z.object({
    date: isoDate, valueCents: cents, lowCents: cents, highCents: cents,
    comps: zod_1.z.array(exports.EstateValuationCompSchema).max(10).default([]),
    /** Normalized `line1|city|state|zip5` the value was fetched for — a mismatch with the current address = stale. */
    addressKey: zod_1.z.string().max(400).optional(),
});
exports.EstateAreaTrendPointSchema = zod_1.z.object({
    month: zod_1.z.string().regex(/^\d{4}-\d{2}$/), medianCents: cents,
});
exports.EstateRentEstimateSchema = zod_1.z.object({
    lowCents: cents, pointCents: cents, highCents: cents,
    comps: zod_1.z.number().int().min(0).max(100), asOf: zod_1.z.string().max(40),
    /** Normalized `line1|city|state|zip5` the estimate was fetched for. pointCents 0 = Ruby tried and could not price it. */
    addressKey: zod_1.z.string().max(400).optional(),
});
// ── Property ──
exports.EstatePropertyInputSchema = zod_1.z.object({
    name: text(120).min(1),
    kind: zod_1.z.enum(['residential', 'commercial', 'mixed']).default('residential'),
    address: Address,
    photoKeys: keys,
    notes: text(2000).default(''),
    // ── 2026-10-11 property hub (all optional / defaulted) ──
    subtype: exports.EstatePropertySubtypeSchema.optional(),
    geo: Geo.optional(),
    facts: exports.EstatePropertyFactsSchema,
    // active:false = "Use Ruby's estimate instead" — the figure is kept but no longer the current value.
    ownValue: zod_1.z.object({
        valueCents: positiveCents, asOf: isoDate, note: text(200).default(''), active: zod_1.z.boolean().default(true),
    }).optional(),
    valuations: zod_1.z.array(exports.EstateValuationPointSchema).max(120).default([]),
    latestValuation: exports.EstateLatestValuationSchema.optional(),
    areaTrend: zod_1.z.array(exports.EstateAreaTrendPointSchema).max(36).default([]),
    // 2026-10-15: set once on the property, every lease of it follows (owner).
    renterInsurance: zod_1.z.object({
        required: zod_1.z.boolean().default(false),
        minLiabilityCents: cents.optional(),
        notes: text(300).default(''),
    }).optional(),
    // 2026-10-15: which photo leads the Overview (absent = first upload).
    coverPhoto: zod_1.z.enum(['upload', 'satellite']).optional(),
});
/** C6 (2026-10-15): pointer to the property's master lease (`MASTERLEASE#<propertyId>#vNNNN`). Server-set. */
exports.EstatePropertyMasterLeaseStateSchema = zod_1.z.object({
    latestVersion: zod_1.z.number().int().min(1), updatedAt: zod_1.z.string(),
});
exports.EstatePropertySchema = exports.EstatePropertyInputSchema.extend({
    propertyId: id,
    masterLease: exports.EstatePropertyMasterLeaseStateSchema.optional(),
    ...meta,
});
// ── Unit + listing ──
exports.EstateListingSchema = zod_1.z.object({
    published: zod_1.z.boolean().default(false),
    headline: text(140).default(''),
    description: text(4000).default(''),
    askingRentCents: cents.default(0),
    depositCents: cents.default(0),
    availableFrom: isoDate.optional(),
    pets: text(140).default(''),
    photoKeys: keys,
}).default({});
// 2026-10-15 unit page sections (full-page Add/Edit unit + the Unit page).
exports.ESTATE_UNIT_SECTIONS = ['details', 'photos', 'amenities', 'storage', 'utilities', 'equipment', 'safety', 'special', 'notices'];
exports.ESTATE_UNIT_UNAVAILABLE_REASONS = ['out_of_order', 'renovation', 'owner_use', 'other'];
exports.ESTATE_EQUIPMENT_KINDS = ['hvac', 'furnace', 'water_heater', 'refrigerator', 'stove', 'dishwasher', 'washer', 'dryer', 'microwave', 'garbage_disposal', 'smoke_detector', 'pest_control', 'other'];
exports.EstateUnitStorageSchema = zod_1.z.object({
    kind: zod_1.z.enum(['storage', 'parking', 'bike', 'other']),
    ref: text(60).default(''), // "B-12", "Space 7"
    location: text(140).default(''),
});
exports.EstateUnitUtilitySchema = zod_1.z.object({
    utility: zod_1.z.enum(['water', 'electric', 'gas', 'trash', 'sewer', 'internet', 'other']),
    paidBy: zod_1.z.enum(['included', 'resident']),
    meter: text(80).default(''), // meter / account number -- always landlord-only
});
exports.EstateUnitEquipmentSchema = zod_1.z.object({
    equipmentId: zod_1.z.string().min(1).max(80), // client-minted, stable -- work orders point at it
    kind: zod_1.z.enum(exports.ESTATE_EQUIPMENT_KINDS),
    name: text(80).default(''),
    makeModel: text(140).default(''),
    serial: text(80).default(''),
    location: text(140).default(''),
    installedOn: isoDate.optional(),
    warrantyUntil: isoDate.optional(),
    notes: text(1000).default(''),
});
exports.EstateUnitNoticeSchema = zod_1.z.object({
    noticeId: zod_1.z.string().min(1).max(80),
    kind: zod_1.z.enum(['entry', 'rent_change', 'general', 'violation', 'other']).default('general'),
    title: text(140).min(1),
    date: isoDate, // date served / effective
    notes: text(1000).default(''),
});
exports.EstateUnitInputSchema = zod_1.z.object({
    label: text(80).min(1),
    sqft: zod_1.z.number().int().min(0).max(1000000).optional(),
    beds: zod_1.z.number().min(0).max(50).optional(),
    baths: zod_1.z.number().min(0).max(50).optional(),
    status: zod_1.z.enum(['vacant', 'occupied', 'unavailable']).default('vacant'),
    marketRentCents: cents.default(0),
    listing: exports.EstateListingSchema,
    rentEstimate: exports.EstateRentEstimateSchema.optional(), // 2026-10-11 property hub
    // 2026-10-15: amenities the unit comes with (they flow into its lease as a checklist), and
    // whether pets are allowed in it at all (unset = the landlord decides per lease).
    amenities: zod_1.z.array(text(60).min(1)).max(40).default([]),
    petPolicy: zod_1.z.enum(['allowed', 'not_allowed', 'per_lease']).optional(),
    // 2026-10-15 unit page: the full-page unit record. Every section is optional; who sees each one
    // (residents' My Residence page / the public listing vs the landlord only) is `visibility`.
    floor: text(20).optional(),
    photoKeys: keys,
    storage: zod_1.z.array(exports.EstateUnitStorageSchema).max(20).default([]),
    utilities: zod_1.z.array(exports.EstateUnitUtilitySchema).max(12).default([]),
    equipment: zod_1.z.array(exports.EstateUnitEquipmentSchema).max(40).default([]),
    safetyInstructions: text(4000).default(''),
    specialInfo: text(4000).default(''),
    notices: zod_1.z.array(exports.EstateUnitNoticeSchema).max(100).default([]),
    visibility: zod_1.z.record(zod_1.z.enum(exports.ESTATE_UNIT_SECTIONS), zod_1.z.enum(['shared', 'private'])).optional(),
});
// Set ONLY by property-service-ext's POST /units/{id}/status (never through the plain unit PUT,
// whose input schema strips them): deactivate (status 'unavailable' + reason), demo/model unit,
// and remove (a soft delete -- hidden from every list, still resolvable by id for old records).
exports.EstateUnitSchema = exports.EstateUnitInputSchema.extend({
    unitId: id, propertyId: id,
    isDemo: zod_1.z.boolean().optional(),
    unavailableReason: zod_1.z.enum(exports.ESTATE_UNIT_UNAVAILABLE_REASONS).optional(),
    unavailableNote: text(280).optional(),
    unavailableUntil: isoDate.optional(),
    removedAt: zod_1.z.string().max(40).optional(),
    ...meta,
});
/** Who sees a unit section when the landlord hasn't chosen: listing basics + what a resident needs
 * are shared; equipment (serials, costs) and special information (codes, keys) stay private. */
exports.ESTATE_UNIT_SECTION_DEFAULTS = {
    details: 'shared', photos: 'shared', amenities: 'shared', storage: 'shared', utilities: 'shared',
    equipment: 'private', safety: 'shared', special: 'private', notices: 'shared',
};
function estateUnitSectionShared(unit, section) {
    return (unit.visibility?.[section] ?? exports.ESTATE_UNIT_SECTION_DEFAULTS[section]) === 'shared';
}
/** Counted in occupancy / unit totals: not removed, not a demo (model) unit. */
function estateUnitCounted(u) {
    return !u.removedAt && !u.isDemo;
}
/** Why a unit can't take a new lease or application, or null when it can. */
function estateUnitBlockReason(u) {
    if (u.removedAt)
        return 'unit_removed';
    if (u.isDemo)
        return 'unit_demo';
    if (u.status === 'unavailable')
        return 'unit_unavailable';
    return null;
}
// ── Resident ──
// 2026-10-15: one screening record on the resident page -- a background check or a financial
// report (credit, income, eviction, references), recorded by the landlord with the report file.
exports.ESTATE_SCREENING_KINDS = ['background', 'credit', 'income', 'eviction', 'reference', 'other'];
exports.EstateResidentScreeningSchema = zod_1.z.object({
    screeningId: zod_1.z.string().min(1).max(80),
    kind: zod_1.z.enum(exports.ESTATE_SCREENING_KINDS),
    provider: text(120).default(''),
    date: isoDate,
    result: zod_1.z.enum(['pending', 'pass', 'review', 'fail']).default('pending'),
    score: zod_1.z.number().int().min(0).max(1000).optional(),
    monthlyIncomeCents: cents.optional(),
    notes: text(1000).default(''),
    docKeys: keys,
});
exports.EstateResidentInputSchema = zod_1.z.object({
    name: text(160).min(1),
    kind: zod_1.z.enum(['person', 'business']).default('person'),
    email: zod_1.z.string().trim().toLowerCase().email().max(254),
    phone: text(40).default(''),
    unitId: id.optional(),
    insurance: zod_1.z.object({
        provider: text(120).default(''), expiresOn: isoDate.optional(), docKey: zod_1.z.string().max(512).optional(),
        // 2026-10-15 (additive): resident page Insurance tab.
        policyNumber: text(80).optional(), liabilityCents: cents.optional(),
    }).default({}),
    notes: text(2000).default(''),
    screening: zod_1.z.array(exports.EstateResidentScreeningSchema).max(50).default([]),
});
exports.EstateResidentSchema = exports.EstateResidentInputSchema.extend({
    residentId: id, cognitoSub: zod_1.z.string().max(80).optional(),
    // Set by POST /residents/{id}/invite -- an ISO timestamp gating the once-per-hour resend
    // cooldown (never user-settable; merchant residents routes never accept it as input).
    lastInvitedAt: zod_1.z.string().max(40).optional(),
    ...meta,
});
// ── Lease ──
const RecurringCharge = zod_1.z.object({ code: zod_1.z.enum(['cam', 'utility', 'parking', 'storage', 'pet', 'other']), label: text(80).min(1), amountCents: positiveCents });
// ── Lease guarantors + e-signature (spec 2026-10-15 estate-lease-esign-master, C5) ──
exports.EstateLeaseGuarantorSchema = zod_1.z.object({
    name: text(160).min(1),
    email: zod_1.z.string().trim().toLowerCase().email().max(254),
});
exports.ESTATE_LEASE_SIGNER_ROLES = ['resident', 'guarantor', 'landlord'];
/** Packet status (mirrors the engine's tenant-envelope view; never `draft`). */
exports.ESTATE_LEASE_SIGNING_STATUSES = ['sent', 'partially_signed', 'executed', 'declined', 'voided', 'expired'];
exports.ESTATE_LEASE_SIGNING_SIGNER_STATUSES = ['sent', 'viewed', 'signed', 'declined'];
exports.EstateLeaseSigningSignerSchema = zod_1.z.object({
    key: zod_1.z.string().min(1).max(40),
    role: zod_1.z.enum(exports.ESTATE_LEASE_SIGNER_ROLES),
    name: text(160), email: text(254),
    status: zod_1.z.enum(exports.ESTATE_LEASE_SIGNING_SIGNER_STATUSES),
    signedAt: zod_1.z.string().optional(),
    declinedReason: text(500).optional(),
});
/** `lease.signing` — the in-flight or finished e-signature packet for one doc version. */
exports.EstateLeaseSigningSchema = zod_1.z.object({
    envelopeId: zod_1.z.string().min(1).max(120),
    version: zod_1.z.number().int().min(1),
    sentAt: zod_1.z.string(),
    status: zod_1.z.enum(exports.ESTATE_LEASE_SIGNING_STATUSES),
    signers: zod_1.z.array(exports.EstateLeaseSigningSignerSchema).max(16),
    updatedAt: zod_1.z.string(),
    /** Final wave I2: sha256 of the guarantors the packet was sent with (`leaseGuarantorsSha256`). */
    guarantorsSha256: zod_1.z.string().regex(/^[0-9a-f]{64}$/).optional(),
});
// ── Lease workspace (spec 2026-10-14) ──
const Payer = zod_1.z.enum(['landlord', 'resident', 'shared']);
exports.EstateLeaseExtrasSchema = zod_1.z.object({
    pets: zod_1.z.object({
        allowed: zod_1.z.boolean().default(false),
        maxCount: zod_1.z.number().int().min(0).max(10).optional(),
        kinds: text(200).default(''),
        depositCents: cents.optional(),
        notes: text(500).default(''),
    }).default({}),
    parking: zod_1.z.object({ spaces: zod_1.z.number().int().min(0).max(20).default(0), details: text(300).default('') }).default({}),
    storage: zod_1.z.object({ included: zod_1.z.boolean().default(false), details: text(300).default('') }).default({}),
    utilities: zod_1.z.object({
        water: Payer.optional(), electric: Payer.optional(), gas: Payer.optional(),
        trash: Payer.optional(), internet: Payer.optional(), sewer: Payer.optional(),
    }).default({}),
    rules: zod_1.z.object({
        smoking: zod_1.z.enum(['no', 'outside', 'yes']).default('no'),
        subletting: zod_1.z.boolean().default(false),
        renterInsurance: zod_1.z.boolean().default(false),
    }).default({}),
    conditions: zod_1.z.array(text(300).min(1)).max(20).default([]),
    // 2026-10-15: the unit's amenities this lease includes (a checklist of unit.amenities).
    // Unset = every amenity the unit has; property-service fills it from the unit on create.
    amenities: zod_1.z.array(text(60).min(1)).max(40).optional(),
});
exports.EstateLeaseInputSchema = zod_1.z.object({
    unitId: id, propertyId: id,
    residentIds: zod_1.z.array(id).min(1).max(10),
    startDate: isoDate,
    endDate: isoDate.optional(),
    rentCents: cents.default(0),
    dueDay: zod_1.z.number().int().min(1).max(31),
    recurringCharges: zod_1.z.array(RecurringCharge).max(10).default([]),
    escalation: zod_1.z.object({ percentBps: bps, month: zod_1.z.number().int().min(1).max(12) }).optional(),
    lateFee: zod_1.z.object({
        graceDays: zod_1.z.number().int().min(0).max(31).default(5),
        type: zod_1.z.enum(['flat', 'percent']).default('flat'),
        amountCents: cents.default(0),
        percentBps: bps.default(0),
    }).default({}),
    depositCents: cents.default(0),
    status: zod_1.z.enum(['draft', 'active', 'ended']).default('draft'),
    docKeys: keys,
    extras: exports.EstateLeaseExtrasSchema.default({}),
    // 2026-10-15 (C5): personal guarantors who sign the lease (editable while draft).
    guarantors: zod_1.z.array(exports.EstateLeaseGuarantorSchema).max(5).default([]),
});
exports.EstateLeaseActorSchema = zod_1.z.object({ sub: zod_1.z.string().max(80), name: text(160).default(''), email: text(254).default('') });
/** `lease.signedOutside` — signed on paper / another tool; the uploaded copy satisfies the activate gate. */
exports.EstateLeaseSignedOutsideSchema = zod_1.z.object({
    at: zod_1.z.string(), by: exports.EstateLeaseActorSchema, docKey: zod_1.z.string().min(1).max(512),
    /** Final wave M5: the approved document version the signed copy covers. */
    version: zod_1.z.number().int().min(1).optional(),
});
exports.EstateLawSourceSchema = zod_1.z.object({ title: text(200), url: zod_1.z.string().max(2000) });
exports.EstateLawSuggestionSchema = zod_1.z.object({
    id: text(40).min(1),
    severity: zod_1.z.enum(['required', 'recommended', 'info']),
    topic: zod_1.z.enum(['deposit', 'late_fee', 'rent', 'notice', 'entry', 'disclosure', 'habitability', 'fair_housing', 'pets', 'other']),
    title: text(80).min(1),
    detail: text(400).min(1),
    sourceIdx: zod_1.z.array(zod_1.z.number().int().min(0).max(19)).min(1).max(5),
    apply: zod_1.z.object({
        field: zod_1.z.enum(['depositCents', 'lateFee.graceDays', 'lateFee.amountCents', 'lateFee.percentBps']),
        value: zod_1.z.number().int().min(0).max(100000000),
    }).optional(),
});
exports.EstateLawReviewSchema = zod_1.z.object({
    items: zod_1.z.array(exports.EstateLawSuggestionSchema).max(25),
    sources: zod_1.z.array(exports.EstateLawSourceSchema).max(20),
    at: zod_1.z.string(), termsSha256: zod_1.z.string().length(64),
    actionId: zod_1.z.string().max(80), jobId: zod_1.z.string().max(120), disclaimerVersion: zod_1.z.string().max(40),
});
// ── Review-with-Ruby (spec 2026-10-15): per-section verdicts on a lease body. Ruby never
// edits the text itself -- "Use this wording" replaces a section with `suggestion` as a new version.
exports.EstateLeaseReviewSectionSchema = zod_1.z.object({
    index: zod_1.z.number().int().min(0),
    heading: text(200),
    verdict: zod_1.z.enum(['ok', 'worry', 'fix', 'illegal']),
    reason: text(600),
    sourceIdx: zod_1.z.array(zod_1.z.number().int().min(0).max(19)).max(5).default([]),
    suggestion: zod_1.z.string().max(6000).optional(),
});
exports.EstateLeaseDocumentStateSchema = zod_1.z.object({
    status: zod_1.z.enum(['none', 'generating', 'draft', 'approved']).default('none'),
    latestVersion: zod_1.z.number().int().min(0).default(0),
    approvedVersion: zod_1.z.number().int().min(1).nullable().optional(),
    approvedAt: zod_1.z.string().nullable().optional(),
    approvedTermsSha256: zod_1.z.string().length(64).nullable().optional(),
    pendingJob: zod_1.z.object({
        jobId: zod_1.z.string().max(120), kind: zod_1.z.enum(['law_review', 'lease_draft', 'lease_review', 'lease_templatize']), startedAt: zod_1.z.string(),
        /** Terms hash the job was started for (resumed law checks save with it). Additive, optional. */
        termsSha256: zod_1.z.string().length(64).optional(),
        /** lease_review only: the exact doc version Ruby is reviewing (resume saves onto it). Additive, optional. */
        version: zod_1.z.number().int().min(1).optional(),
    }).nullable().optional(),
}).default({});
exports.EstateLeaseAttestationSchema = zod_1.z.object({
    at: zod_1.z.string(), actor: exports.EstateLeaseActorSchema, ip: zod_1.z.string().max(64).default(''), userAgent: zod_1.z.string().max(400).default(''),
    disclaimerKey: zod_1.z.enum(['ruby_lease_ai', 'own_lease']), disclaimerVersion: zod_1.z.string().max(40), disclaimerSha256: zod_1.z.string().length(64),
    acknowledgements: zod_1.z.array(zod_1.z.string().max(600)).min(1).max(5),
    bodySha256: zod_1.z.string().length(64), termsSha256: zod_1.z.string().length(64),
});
exports.EstateLeaseDocVersionSchema = zod_1.z.object({
    leaseId: id, version: zod_1.z.number().int().min(1),
    /** 'master' (2026-10-15): v1 of a lease started from the property master lease. */
    source: zod_1.z.enum(['ruby', 'edited', 'own', 'master']),
    /** Who wrote the underlying text: 'ruby' or the landlord's 'own' lease. An `edited` version
     *  inherits it from the version it was edited from. Additive, optional (legacy rows: derive
     *  from `source`). Picks the approval disclaimer. */
    origin: zod_1.z.enum(['ruby', 'own']).optional(),
    body: zod_1.z.string().max(120000),
    bodySha256: zod_1.z.string().length(64), termsSha256: zod_1.z.string().length(64),
    status: zod_1.z.enum(['draft', 'approved', 'rejected', 'superseded']),
    createdAt: zod_1.z.string(), createdBy: exports.EstateLeaseActorSchema,
    ruby: zod_1.z.object({ jobId: zod_1.z.string().max(120), actionId: zod_1.z.string().max(80), rubyTokensUsed: zod_1.z.number().min(0).default(0) }).optional(),
    approval: exports.EstateLeaseAttestationSchema.optional(),
    rejection: zod_1.z.object({ at: zod_1.z.string(), by: exports.EstateLeaseActorSchema, reason: text(500).default('') }).optional(),
    /** Review-with-Ruby result for this version's body (spec 2026-10-15). Additive, optional --
     *  a version with no review simply hasn't been reviewed yet. */
    review: zod_1.z.object({
        at: zod_1.z.string(), jobId: zod_1.z.string().max(120), actionId: zod_1.z.string().max(80), bodySha256: zod_1.z.string().length(64),
        sections: zod_1.z.array(exports.EstateLeaseReviewSectionSchema).max(80),
        sources: zod_1.z.array(exports.EstateLawSourceSchema).max(20),
        summary: text(600),
    }).optional(),
    /** source 'master' only: which master version this lease version was started from. Additive. */
    fromMaster: zod_1.z.object({ propertyId: id, version: zod_1.z.number().int().min(1) }).optional(),
    tenantId: id,
});
exports.ESTATE_LEASE_AUDIT_TYPES = ['created', 'policy_accepted', 'law_review_started', 'law_review_saved', 'draft_requested',
    'version_saved', 'version_approved', 'version_rejected', 'activated', 'review_saved',
    // 2026-10-15 e-signature + master lease (C5)
    'signing_sent', 'signer_signed', 'signer_declined', 'countersigned', 'signing_executed',
    'signing_voided', 'signed_outside', 'master_saved', 'lease_from_master'];
exports.EstateLeaseAuditEventSchema = zod_1.z.object({
    leaseId: id, type: zod_1.z.enum(exports.ESTATE_LEASE_AUDIT_TYPES), at: zod_1.z.string(), actor: exports.EstateLeaseActorSchema,
    ip: zod_1.z.string().max(64).default(''), userAgent: zod_1.z.string().max(400).default(''),
    version: zod_1.z.number().int().min(1).optional(),
    disclaimer: zod_1.z.object({ key: zod_1.z.string().max(40), version: zod_1.z.string().max(40), sha256: zod_1.z.string().length(64) }).optional(),
    detail: zod_1.z.record(zod_1.z.unknown()).optional(),
    tenantId: id,
});
// ── Property master lease (C6). `MASTERLEASE#<propertyId>#vNNNN` / `MASTERAUDIT#…`. ──
/** Same shape as a lease doc version, keyed by property instead of lease. `termsSha256` is
 *  whatever the writer stamps (a master has no lease terms). `fromLease` = the approved lease
 *  it was templatized from, when it was. */
exports.EstateMasterLeaseVersionSchema = exports.EstateLeaseDocVersionSchema.omit({ leaseId: true }).extend({
    propertyId: id,
    fromLease: zod_1.z.object({ leaseId: id, version: zod_1.z.number().int().min(1) }).optional(),
});
exports.EstateMasterLeaseAuditEventSchema = exports.EstateLeaseAuditEventSchema.omit({ leaseId: true }).extend({ propertyId: id });
exports.EstateLeaseSchema = exports.EstateLeaseInputSchema.extend({
    leaseId: id,
    autopay: zod_1.z.object({
        enabled: zod_1.z.boolean().default(false),
        stripeCustomerId: zod_1.z.string().max(80).optional(),
        // The resident the Stripe customer was created for -- property-service reuses a customer for
        // a resident's next lease only when this matches (never a co-resident's). Optional/additive.
        stripeCustomerResidentId: zod_1.z.string().max(80).optional(),
        paymentMethodId: zod_1.z.string().max(80).optional(),
        method: zod_1.z.enum(['ach', 'card']).optional(),
    }).default({}),
    // `endDate:offset` of the last lease-end reminder sent (same `dueDate:offset` key shape as the
    // obligation's lastRemindedFor) -- prevents the daily job re-firing the same 90/60/30 reminder.
    leaseEndRemindedFor: zod_1.z.string().max(40).optional(),
    // Set by POST /leases/{id}/activate -- the daily job's billing floor is this (falling back to
    // createdAt, then startDate) so a lease with a backdated startDate never back-bills periods
    // that predate when it was actually turned on.
    activatedAt: isoDate.optional(),
    document: exports.EstateLeaseDocumentStateSchema,
    lawReview: exports.EstateLawReviewSchema.optional(),
    // 2026-10-15 (C5): the e-signature packet, and the "signed outside RubyTill" alternative.
    signing: exports.EstateLeaseSigningSchema.optional(),
    signedOutside: exports.EstateLeaseSignedOutsideSchema.optional(),
    ...meta,
});
// ── Ledger ──
exports.LEDGER_KINDS = ['charge', 'late_fee', 'payment', 'credit', 'deposit', 'deposit_refund'];
exports.EstateLedgerInputSchema = zod_1.z.object({
    kind: zod_1.z.enum(exports.LEDGER_KINDS),
    code: zod_1.z.enum(['rent', 'cam', 'utility', 'parking', 'storage', 'pet', 'late_fee', 'deposit', 'other']),
    label: text(120).min(1),
    amountCents: positiveCents,
    date: isoDate,
    method: zod_1.z.enum(['ach', 'card', 'cash', 'check', 'other']).optional(),
    memo: text(500).default(''),
    // 'requires_action' (Task 31 fix round 1): a PaymentIntent needing 3DS/a new payment method at
    // confirm time -- excluded from every balance calculation (rent.ts's `counts()` only treats
    // 'posted'/'processing' as money in flight), so it never silently counts as paid.
    status: zod_1.z.enum(['posted', 'processing', 'failed', 'void', 'requires_action']).default('posted'),
});
exports.EstateLedgerEntrySchema = exports.EstateLedgerInputSchema.extend({
    entryId: id, leaseId: id, periodKey: zod_1.z.string().regex(/^\d{4}-\d{2}$/),
    stripePaymentIntentId: zod_1.z.string().max(80).optional(),
    applicationFeeCents: cents.optional(),
    feePlanId: zod_1.z.string().max(80).optional(),
    feeSource: zod_1.z.enum(['override', 'deal', 'default', 'platform']).optional(),
    source: zod_1.z.enum(['manual', 'schedule', 'resident', 'autopay', 'webhook']).default('manual'),
    // Task 31 pre-review fix: set EXACTLY ONCE by the Stripe Connect webhook's
    // payment_intent.succeeded handler, via a conditional update (attribute_not_exists(settledAt)).
    // This is the settlement idempotency key -- NOT `status` -- so a payment that pay()/chargeAutopay
    // already posted as 'posted' (a PaymentIntent that resolved synchronously) still gets its
    // receipt + platform fee record from the first webhook delivery that actually settles it.
    settledAt: zod_1.z.string().max(40).optional(),
    ...meta,
});
// ── Obligation (bills, insurance, tax, permits) ──
exports.EstateObligationInputSchema = zod_1.z.object({
    propertyId: id.optional(),
    kind: zod_1.z.enum(['insurance', 'property_tax', 'permit', 'loan', 'hoa', 'utility', 'other']),
    title: text(140).min(1),
    payee: text(140).default(''),
    amountCents: cents.optional(),
    dueDate: isoDate,
    recurrence: zod_1.z.enum(['none', 'monthly', 'quarterly', 'semiannual', 'annual']).default('none'),
    remindDaysBefore: zod_1.z.array(zod_1.z.number().int().min(0).max(365)).max(5).default([30, 7, 1]),
    docKeys: keys,
    notes: text(2000).default(''),
});
exports.EstateObligationSchema = exports.EstateObligationInputSchema.extend({
    obligationId: id, status: zod_1.z.enum(['open', 'paid']).default('open'),
    lastRemindedFor: zod_1.z.string().max(40).optional(),
    // The first obligation in a roll-forward chain; absent on it, set on every obligation it rolls
    // forward into -- lets a constant-length deterministic id be derived (seriesId + due date)
    // instead of growing the id with every rollover.
    seriesId: zod_1.z.string().max(80).optional(),
    ...meta,
});
// ── Work order ──
// 2026-10-15: + hvac (heating & cooling) and pest_control, so a unit's equipment / pest history
// can be read straight off its work orders.
const WO_CATEGORY = zod_1.z.enum(['heating', 'plumbing', 'electrical', 'appliance', 'doors_locks', 'exterior', 'other', 'hvac', 'pest_control']);
exports.EstateResidentWorkOrderInputSchema = zod_1.z.object({
    category: WO_CATEGORY,
    title: text(140).min(1),
    description: text(4000).default(''),
    urgency: zod_1.z.enum(['low', 'normal', 'urgent']).default('normal'),
    permissionToEnter: zod_1.z.boolean().default(false),
    photoKeys: keys,
}).strict();
exports.EstateWorkOrderInputSchema = exports.EstateResidentWorkOrderInputSchema.extend({
    propertyId: id, unitId: id.optional(), residentId: id.optional(),
    equipmentId: zod_1.z.string().min(1).max(80).optional(), // 2026-10-15: the unit equipment this job was for
    status: zod_1.z.enum(['new', 'scheduled', 'in_progress', 'waiting', 'done', 'cancelled']).default('new'),
    vendorId: id.optional(), scheduledFor: zod_1.z.string().max(40).optional(), costCents: cents.optional(),
}).strict();
exports.EstateWorkOrderSchema = exports.EstateWorkOrderInputSchema.extend({
    workOrderId: id,
    timeline: zod_1.z.array(zod_1.z.object({ at: zod_1.z.string(), status: zod_1.z.string(), note: text(1000).default(''), by: zod_1.z.string().max(80) })).default([]),
    ...meta,
});
// ── Vendor (maintenance company / tradesperson profile) ──
exports.EstateVendorInputSchema = zod_1.z.object({
    name: text(140).min(1),
    kind: zod_1.z.enum(['company', 'person']).default('company'),
    contactName: text(140).default(''),
    trade: text(80).default(''), // kept for back-compat (primary trade)
    trades: zod_1.z.array(zod_1.z.enum(['general', 'plumbing', 'electrical', 'hvac', 'appliance', 'locksmith', 'roofing', 'landscaping', 'cleaning', 'pest', 'painting', 'other'])).max(12).default([]),
    phone: text(40).default(''), email: zod_1.z.string().trim().toLowerCase().email().max(254).optional(),
    serviceAreas: zod_1.z.array(text(80)).max(20).default([]),
    hourlyRateCents: cents.optional(), calloutFeeCents: cents.optional(),
    emergency24h: zod_1.z.boolean().default(false),
    licenseNumber: text(80).default(''), licenseExpiresOn: isoDate.optional(),
    insuranceExpiresOn: isoDate.optional(), docKeys: keys, // license / insurance certificates (uploads-service keys)
    preferred: zod_1.z.boolean().default(false),
    propertyIds: zod_1.z.array(id).max(50).default([]), // empty = all properties
    notes: text(2000).default(''),
});
exports.EstateVendorSchema = exports.EstateVendorInputSchema.extend({ vendorId: id, ...meta });
// ── Application ──
exports.EstateApplicationInputSchema = zod_1.z.object({
    unitId: id,
    name: text(160).min(1),
    phone: text(40).default(''),
    moveInDate: isoDate.optional(),
    message: text(4000).default(''),
    docKeys: keys,
});
exports.EstateApplicationSchema = exports.EstateApplicationInputSchema.extend({
    applicationId: id, propertyId: id, cognitoSub: zod_1.z.string().max(80), email: zod_1.z.string().max(254),
    status: zod_1.z.enum(['new', 'approved', 'declined']).default('new'),
    residentId: id.optional(),
    // Whether `email` was a verified Cognito claim at submission time (resident/applications
    // always stamps true, since it already requires a verified token). Optional/absent on rows
    // written before this field existed, or by an import/seed -- those must never be treated as
    // verified by anything that trusts `email` for an identity decision (e.g. linking an existing
    // resident on approval).
    emailVerified: zod_1.z.boolean().optional(),
    ...meta,
});
// ── Settings (per business) ──
exports.EstateSettingsSchema = zod_1.z.object({
    timezone: zod_1.z.string().max(60).default('America/Los_Angeles'),
    stripeAccountId: zod_1.z.string().max(80).optional(),
    chargesEnabled: zod_1.z.boolean().default(false),
    payoutsEnabled: zod_1.z.boolean().default(false),
    feePayer: zod_1.z.enum(['landlord', 'resident']).default('landlord'),
    // 2026-10-15 identity verification (spec 2026-10-15-identity-verification-design §3).
    identity: zod_1.z.object({
        requireForApplications: zod_1.z.boolean().default(false),
        ssnByDefault: zod_1.z.boolean().default(false),
        retainYearsAfterLease: zod_1.z.number().int().min(1).max(20).default(6),
    }).default({}),
});
//# sourceMappingURL=estate.js.map